import { useLocation } from 'react-router-dom';
import { BANDA_IN_LUCRU_ACTIVA, bandaSeAscundePeMobil } from '@/shared/utils/banda-in-lucru-flag';
import { cn } from '@/lib/utils';

/**
 * Banda discreta „Platforma e în lucru", stanga-jos, pe paginile publice SI dupa login.
 *
 * O SINGURA componenta, montata in ambele layout-uri (`UnauthenticatedLayout.jsx`,
 * `AuthenticatedLayout.tsx`) — nu doua copii, ca sa nu diveraga la primul text schimbat.
 *
 * `position: fixed` iese din orice container cu `overflow:hidden` din lant (shell-ul
 * autentificat taie overflow-ul neconditionat — vezi SE-19), deci pozitia stanga-jos ramane
 * corecta indiferent de pagina. `z-[var(--z-sticky)]` (20): sub overlay/modal (30/40), ca sa
 * nu concureze niciodata cu un dialog deschis.
 *
 * ⚠️ 2026-09-16 seara (owner): pe `/profesor/inregistrare` banda se suprapunea vizual cu
 * butonul „Înregistrare!" la 360 — ecranul pe care ECOTIC testeaza joi, pe telefon. Extins
 * 17.09 (FE-M14) pe rutele `/completare-lectie/...`: acelasi tip de coliziune, cu „Mai departe"
 * si „Trimite raspuns". Ramane randata (pentru `pointer-events-none`/`data-banda-in-lucru`, ca
 * sa nu existe doua cai de randare), dar `hidden` sub `md`, doar pe caile astea — vezi
 * `bandaSeAscundePeMobil`.
 */
export function BandaInLucru() {
    const { pathname } = useLocation();

    if (!BANDA_IN_LUCRU_ACTIVA) return null;

    const ascunsaPeMobil = bandaSeAscundePeMobil(pathname);

    return (
        <div
            data-banda-in-lucru
            /* `pointer-events-none`: e informativa, nu interactiva -- pe pagini scurte la
               360px, un buton de submit poate cadea chiar sub ea si `#root` (main.css,
               `overflow:hidden`, `height:100dvh`, DELIBERAT — "CRITICAL... DO NOT REMOVE") nu
               lasa loc pentru un scroll de pagina care sa-l scoata de sub ea. Fara asta, banda
               ar bloca fizic un buton pe care utilizatorul il vede. */
            className={cn(
                'pointer-events-none fixed bottom-2 left-2 z-[var(--z-sticky)] max-w-64',
                'safe-area-bottom rounded-lg border border-hairline bg-white/90 px-2.5 py-1.5',
                'text-smaller leading-snug text-gray-600 shadow-sm backdrop-blur-sm',
                ascunsaPeMobil && 'hidden md:block',
            )}
        >
            Platforma e în lucru · Școala Ecoterrienilor începe pe 21 septembrie
        </div>
    );
}
